import type { Locale } from "@engine/generate/conceptCopy.js";
import { getPwaUi } from "../i18n/pwaUi.js";

export type MountPrivacyViewOptions = {
  locale: Locale;
  onBackHome: () => void;
};

export function mountPrivacyView(
  root: HTMLElement,
  { locale, onBackHome }: MountPrivacyViewOptions
): () => void {
  const ui = getPwaUi(locale);
  root.innerHTML = "";

  const article = document.createElement("article");
  article.className = "privacy";
  article.setAttribute("aria-labelledby", "privacy-title");

  const back = document.createElement("button");
  back.type = "button";
  back.className = "privacy-back";
  back.textContent = ui.privacyBackHome;
  back.addEventListener("click", () => onBackHome());
  article.appendChild(back);

  const title = document.createElement("h1");
  title.id = "privacy-title";
  title.className = "privacy-title";
  title.textContent = ui.privacyTitle;
  article.appendChild(title);

  const intro = document.createElement("p");
  intro.className = "privacy-intro";
  intro.textContent = ui.privacyIntro;
  article.appendChild(intro);

  const sections: ReadonlyArray<{ heading: string; body: string }> = [
    { heading: ui.privacyWhatWeDelete, body: ui.privacyWhatWeDeleteBody },
    { heading: ui.privacyWhatWeKeepAnon, body: ui.privacyWhatWeKeepAnonBody },
    { heading: ui.privacyHowToDelete, body: ui.privacyHowToDeleteBody },
  ];
  for (const { heading, body } of sections) {
    const section = document.createElement("section");
    section.className = "privacy-section";
    const h2 = document.createElement("h2");
    h2.className = "privacy-section-title";
    h2.textContent = heading;
    const p = document.createElement("p");
    p.className = "privacy-section-body";
    p.textContent = body;
    section.appendChild(h2);
    section.appendChild(p);
    article.appendChild(section);
  }

  root.appendChild(article);

  return (): void => {
    if (article.parentElement === root) root.removeChild(article);
  };
}
